import 'css/app.scss';
import 'react-flexbox-grid';

import 'core-js/stable';

import React from 'react';
import ReactDOM from 'react-dom';
import Parse from 'parse';
import _ from 'lodash';

import { BrowserRouter } from 'react-router-dom'
import App from '../shared/app';
import createStore from '../shared/stores/createStore'
import { Provider } from 'react-redux'
import config from 'sharedConfig';
import {loggedIn, anonymousUser, loadLoggedInUser} from 'components/login/actions';
import {loadVariant} from 'components/app/actions';
import {setRequestQueries} from 'components/address/actions';
import {track} from 'shared/models/analytic';
import {setCsrfToken} from 'shared/models/api';
import {startNewSession, isNewSession} from 'shared/utils/sessionStore';
import ScrollPreserver from 'shared/components/ui/scrollPreserver';


window.stripe = Stripe(config.stripe.pk);
Parse.initialize(config.parse.appId, config.parse.key);
Parse.serverURL = config.parse.serverURL;
Parse.Config.current();

// facebook
window.fbAsyncInit = function() {
  Parse.FacebookUtils.init({
    appId      : config.facebook.appId,
    xfbml      : true,
    version    : 'v2.12'
  });
};
(function(d, s, id){
 var js, fjs = d.getElementsByTagName(s)[0];
 if (d.getElementById(id)) {return;}
 js = d.createElement(s); js.id = id;
 js.src = '//connect.facebook.net/en_US/all.js';
 fjs.parentNode.insertBefore(js, fjs);
}(document, 'script', 'facebook-jssdk'));

// branch
(function(b,r,a,n,c,h,_,s,d,k){if(!b[n]||!b[n]._q){for(;s<_.length;)c(h,_[s++]);d=r.createElement(a);d.async=1;d.src="https://cdn.branch.io/branch-latest.min.js";k=r.getElementsByTagName(a)[0];k.parentNode.insertBefore(d,k);b[n]=h}})(window,document,"script","branch",function(b,r){b[r]=function(){b._q.push([r,arguments])}},{_q:[],_v:1},"addListener applyCode banner closeBanner creditHistory credits data deepview deepviewCta first getCode init link logout redeem referrals removeListener sendSMS setIdentity track validateCode".split(" "), 0);
branch.init(config.branch.key);

const csrfToken = document.querySelector('meta[name="csrf-token"]');
if (csrfToken) setCsrfToken(csrfToken.content);

const store = createStore(window.__PRELOADED_STATE__, {
  menuURL: config.menu.baseUrl,
  brandTemplateURL: config.brandTemplates.url
});

window.loadVariant = function(experimentName, variantName) {
  store.dispatch(loadVariant(experimentName, variantName));
}

window.registerLoyaltyEvent = function(event) {
  const requiresRefresh = (store.getState().loyalty.performableActions || [])
    .map(action => action.event)
    .indexOf(event) !== -1;
  if (requiresRefresh) setTimeout(() => store.dispatch(loadLoggedInUser()), 250);
}

if (__PRELOADED_STATE__.address) {
  setRequestQueries(__PRELOADED_STATE__.address);
  if (!_.isEmpty(__PRELOADED_STATE__.address.address) && isNewSession()) {
    track('Delivery Address Set', { source: 'cache' })
  }
}

ReactDOM.hydrate(
  <Provider store={store}>
    <BrowserRouter>
      <ScrollPreserver>
        <App />
      </ScrollPreserver>
    </BrowserRouter>
  </Provider>,
  document.getElementById('app')
);

if (__PRELOADED_STATE__.login && __PRELOADED_STATE__.login.user) {
  loggedIn(__PRELOADED_STATE__.login.user);
} else {
  anonymousUser();
}

startNewSession();
